import {
    GET_STATE_ADAS,
    GET_STATE_ADAS_ERROR,
    GET_STATE_ADAS_SUCCESS,
} from './Camera.actions';

const cameraState = {
    lista: [],
    loading_state: true,
    error_state: undefined,
};

/**
 * The Camera reducer.
 */
const cameraReducer = (state = cameraState, { payload, type }) => {
    switch (type) {
        case GET_STATE_ADAS: {
            return {
                ...state,
                loading_state: true,
                error_state: undefined,
            };
        }
        case GET_STATE_ADAS_ERROR: {
            return {
                ...state,
                loading_state: false,
                error_state: payload.error,
            };
        }
        case GET_STATE_ADAS_SUCCESS: {
            return {
                ...state,
                loading_state: false,
                error_state: undefined,
                lista: payload.lista,
            };
        }
        default:
            return state;
    }
};

export default cameraReducer;